<template>
  <div class="flex flex-col min-h-screen closest-course">
    <BlNavBarMv :title="title" has-back-button data-testid="button-back" class="border-bottom-gray" @handleBackButtonClick="onClickBack" />
    <div class="ml-16 mv-12">
      <BlTextAv weight="bold" variation="body-14" tag="p" data-testid="closest-courses-date" is-bolder>
        {{ closestDate }}
      </BlTextAv>
    </div>
    <div class="ph-16 flex justify-between mb-16">
      <BlButtonAv
        class="c-button mr-8"
        variation="naked"
        size="extra-small"
        data-testid="button-course-type"
        fullwidth
        @click="courseTypePickerActive = true"
      >
        {{ selectedCourseTypeName }}
        <IcoChevronDownMinor size="small" color="#d6d6d6" />
      </BlButtonAv>
      <BlButtonAv
        class="c-button"
        variation="naked"
        size="extra-small"
        data-testid="button-time-frame"
        fullwidth
        @click="timeFramePickerActive = true"
      >
        {{ selectedTimeFrameName }}
        <IcoChevronDownMinor size="small" color="#d6d6d6" />
      </BlButtonAv>
    </div>

    <div v-if="isLoadingClosestCourses" class="mb-12 ph-16 w-full">
      <PrakerjaCardShimmer :count="4" class="pt-12" />
    </div>

    <div v-else-if="isEmptyClass" data-testid="closest_course_empty" class="h-60 flex items-center flex-col justify-center">
      <img
        :src="$publicUrl('images/kartu-prakerja/img_small_zoom_search.webp')"
        alt="closest_courses_empty"
        class="mb-8"
        loading="lazy"
        width="64"
        height="64"
      />
      <BlTextAv variation="subheading-18" class="mb-8" tag="p" weight="bold">Belum ada jadwal kelas</BlTextAv>
      <BlTextAv variation="body-14" tag="p">Coba cek tipe kelas atau jam lainnya, ya.</BlTextAv>
    </div>

    <PrakerjaCourseList v-else :courses="courseList" />

    <BlPickerListMv
      class="sheet"
      title="Tipe kelas"
      data-testid="picker-course-type"
      max-height="auto"
      :is-active.sync="courseTypePickerActive"
      :picker-list="courseType"
      :item-selected="selectedCourseTypeName"
      @selectedItem="handleChangeCourseType"
    />
    <BlPickerListMv
      class="sheet"
      title="Waktu"
      data-testid="picker-time-frame"
      max-height="auto"
      :is-active.sync="timeFramePickerActive"
      :picker-list="timeFrame"
      :item-selected="selectedTimeFrameName"
      @selectedItem="handleChangeTimeFrame"
    />
  </div>
</template>

<script>
import PrakerjaCourseList from '../components/shared/PrakerjaCourseList.vue';
import {IcoChevronDownMinor} from '@bukalapak/bazaar-visual-next';
import {BlTextAv, BlNavBarMv, BlButtonAv, BlPickerListMv} from '@bukalapak/bazaar-mweb-latest';
import trackerGenerator from '../mixins/tracker-generator';
import prakerjaClosestCourses from 'src/shared/mixins/prakerja-closest-course';
import PrakerjaCardShimmer from '../components/PrakerjaCardShimmer/PrakerjaCardShimmer';
import {
  TRACKER_EVENT_VP_PRAKERJA_KELAS_TERDEKAT_FILTER_CLICK,
  TRACKER_EVENT_VP_PRAKERJA_KELAS_TERDEKAT_PAGE_VIEW,
} from '../config/tracker-events';

export default {
  name: 'PrakerjaKelasTerdekatPage',
  components: {
    BlTextAv,
    BlNavBarMv,
    BlPickerListMv,
    BlButtonAv,
    IcoChevronDownMinor,
    PrakerjaCourseList,
    PrakerjaCardShimmer,
  },
  mixins: [trackerGenerator, prakerjaClosestCourses],
  data() {
    return {
      title: 'Kelas dengan jadwal terdekat',
      courseTypePickerActive: false,
      timeFramePickerActive: false,
    };
  },
  computed: {
    courseList() {
      return this.getClosestCourses.map((item) => this.serializeItemToCourse(item));
    },
    selectedCourseTypeName() {
      return this.courseType.find(({value}) => value === this.courseTypeValue.value)?.name;
    },
    selectedTimeFrameName() {
      return this.timeFrame.find(({value}) => value === this.timeFrameValue.value)?.name;
    },
  },
  beforeMount() {
    if (this.$route?.query?.course_type) {
      this.courseTypeValue.value = this.$route?.query?.course_type;
    }
    if (this.$route?.query?.time_frame) {
      this.timeFrameValue.value = this.$route?.query?.time_frame;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
    this.sendVisitTracker();
  },
  methods: {
    init() {
      this.$store.dispatch('sections/fetchPrakerjaClosestCoursesConfig');
      this.courses = this.getClosestCourses.map((item) => this.serializeItemToCourse(item));
    },
    handleChangeCourseType(value) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          course_type: value.value,
        },
      });
      this.courseTypeValue = value;
      this.sendFilterTracker();
    },
    handleChangeTimeFrame(value) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          time_frame: value.value,
        },
      });
      this.timeFrameValue = value;
      this.sendFilterTracker();
    },
    onClickBack() {
      if (!document.referrer.includes(process.env.BASE_PATH)) this.$router.push({name: 'landing'});
      else this.$router.back();
    },
    sendFilterTracker() {
      const trackerPayload = {
        course_type: this.courseTypeValue.value,
        course_timeframe: this.timeFrameValue.value,
        referrer: this.$route.query.referrer || '',
        source: this.$route.query.source || 'direct-access',
      };
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_KELAS_TERDEKAT_FILTER_CLICK, trackerPayload);
    },
    sendVisitTracker() {
      const trackerPayload = {
        referrer: this.$route.query.referrer || '',
        source: this.$route.query.source || 'direct-access',
      };
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_KELAS_TERDEKAT_PAGE_VIEW, trackerPayload);
    },
  },
};
</script>

<style src="@bukalapak/bazaar-mweb-latest/dist/components/BlPickerListMv.css"></style>
<style lang="scss">
.closest-course {
  .c-button {
    border-color: #d6d6d6;
    border-radius: 40px;
    .bl-text {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #141414;
      font-weight: 400;
    }
  }
  .sheet {
    .bl-sheet__nav-bar {
      height: auto;
    }
  }
}
</style>
